import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  CircularProgress,
} from '@material-ui/core';
import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';

const DeleteModal = ({ 
  open, 
  onClose, 
  onConfirm, 
  itemCount = 0, 
  studyCount = 0,
  type = 'studies', // 'studies' or 'patients'
  isLoading = false 
}) => {
  const getMessage = () => {
    if (type === 'studies') {
      if (itemCount === 1) {
        return 'Are you sure you want to permanently delete this study from the database?';
      } else {
        return `Are you sure you want to permanently delete these ${itemCount} studies from the database?`;
      }
    } else {
      // type === 'patients'
      if (itemCount === 1) {
        if (studyCount === 1) {
          return 'Are you sure you want to permanently delete this patient (1 study) from the database?';
        } else {
          return `Are you sure you want to permanently delete this patient (${studyCount} studies) from the database?`;
        }
      } else {
        return `Are you sure you want to permanently delete these ${itemCount} patients (${studyCount} studies) from the database?`;
      }
    }
  };

  return (
    <Dialog open={open} onClose={isLoading ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Confirm Delete
        <IconButton
          onClick={onClose}
          style={{ position: 'absolute', right: 8, top: 8 }}
          disabled={isLoading}
        >
          <Icon path={mdiClose} size={1} />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography>
          {getMessage()}
        </Typography>
        {isLoading && (
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 16 }}>
            Deleting...
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="default" disabled={isLoading}>
          No
        </Button>
        <Button 
          onClick={onConfirm} 
          color="primary" 
          variant="contained"
          disabled={isLoading}
          startIcon={isLoading ? <CircularProgress size={20} /> : null}
        >
          {isLoading ? 'Deleting...' : 'Yes'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteModal;